import { lazy } from 'react'

export const PartnersDataVariant1 = lazy(() => import('./PartnersDataVariant1'))
export const PartnersDataVariant2 = lazy(() => import('./PartnersDataVariant2'))
